import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobsMetricsSummary } from "@/types";

export function useGetJobsMetricsSummary() {
  return useQuery({
    queryKey: ["metrics/scraped-jobs"],
    queryFn: async () => {
      const path = "metrics/scraped-jobs";
      const res = await guacHttpClient.get<
        JobsMetricsSummary,
        HttpResponse<JobsMetricsSummary>
      >(path);

      return res.data;
    },
    // this value doesnt change often so we can cache for a long time
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
  });
}

